import { render } from "./ToolboxBody.vue?vue&type=template&id=4387a8aa"
import script from "./ToolboxBody.vue?vue&type=script&lang=js"
export * from "./ToolboxBody.vue?vue&type=script&lang=js"

import "./ToolboxBody.vue?vue&type=style&index=0&id=4387a8aa&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__